import * as angular from "angular";
import {Link} from "../../models/link.model";

export class BreadcrumbsController {
    crumbs: Link[];

    /* @ngInject */
    constructor(private $location:angular.ILocationService) {}

    followCrumb(crumb: Link) {
        if (crumb.onClick) { crumb.onClick(); }
        this.$location.path(crumb.url);
    }
}


/** WEBPACK FOOTER **
 ** ./~/tslint-loader!./app/common/breadcrumbs/breadcrumbs.controller.ts
 **/